import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, ViewChild, OnDestroy, ViewChildren, AfterViewInit } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSelect } from '@angular/material';
import { AddUserComponent } from './add-user/add-user.component';
import { UpdateUserComponent } from './update-user/update-user.component';
import { AuthoUserComponent } from './autho-user/autho-user.component';
import { UserService } from 'src/app/core/services/user.service';
import { CommonService } from 'src/app/core/services/common.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { AutocompleteComponent } from 'src/app/shared/components/autocomplete/autocomplete.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import { ResponsiveService } from '../../../../../core/services/responsive.service';
import { ImportUserFileComponent } from './../../../../../shared/components/import-user-file/import-user-file.component';
import { Router } from '@angular/router';
import {environment} from "../../../../../../environments/environment";
import { EnvService } from 'src/app/core/services/env.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html'
})
export class UserComponent implements OnInit, OnDestroy, AfterViewInit {
  // displayedColumns: string[] = ['stt', 'enterprise', 'name', 'userName', 'email', 'phone', 'status', 'symbol'];
  isTableLoading = false;
  displayedColumns: string[] = [];

  columnDefinitions = [
    { def: "stt", showMobile: true },
    { def: "enterprise", showMobile: true },
    { def: "name", showMobile: false },
    { def: "userName", showMobile: false },
    { def: "email", showMobile: false },
    { def: "phone", showMobile: false },
    { def: "status", showMobile: true },
    { def: "action", showMobile: true },
  ];
  enterprises = [];
  dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('statusSelect', { static: false }) statusSelect: MatSelect;

  user = {
    enterpriseName: '',
    isActive: 'null',
    keyword: '',
    fullName: '',
    page: 0,
    pageSize: 10
  };
  oldData = this.user;
  paginate: {
    currentPage: number,
    pageSize: number,
    totalRow: number,
    totalPage: number,
    totalPageArray: [],
    no: []
  };
  sme_hub: any;
  isFromSSO = false;
  checkFocus = true;
  // Selected model value for autocomplete
  selectedEnterprise: { id: string, name: '' };
  @ViewChild(AutocompleteComponent, { static: false }) autocompleteComponent: AutocompleteComponent;
  @ViewChildren('focusInput') focusInput;

  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  constructor(
    public notificationService: NotificationService,
    private userService: UserService,
    private dialog: MatDialog,
    public commonService: CommonService,
    private message: Message,
    private toastr: ToastrService,
    private responsiveService: ResponsiveService,
    private router: Router,
    private env:EnvService,
  ) {
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
    this.sme_hub = env.sme_portal_url

  }

  /**
   * Get initial data
   */
  ngOnInit() {
    this.isFromSSO = JSON.parse(localStorage.getItem('isFromSSO'));
    this.loadData(this.paginate.currentPage, this.paginate.pageSize);
    this.notificationService.subscribeErrorService();
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showMobile)
        .map(cd => cd.def);
    } else {
      this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
    }
    // if (this.commonService.getIsLockedEnterprise()) {
    //   this.displayedColumns = this.columnDefinitions
    //     .filter(cd => (cd.def !== 'action' && cd.def !== 'status'))
    //     .map(cd => cd.def);
    // }
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.subscribeMediaBreakPointService.unsubscribe();
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  /**
   * Get initial data
   * @param page: number
   * @param pageSize: number
   */
  loadData(page: number = 0, pageSize: number = 10) {
    this.isTableLoading = true;
    // clear data cu: skeleton la footer-row nam duoi cung bang, neu giu data cu thi no nam
    // duoi man hinh -> clear de skeleton hien ngay duoi header nhu luc vua vao trang
    this.dataSource.data = [];
    this.userService.getAll({
      ...this.user,
      active: [true, false],
      page,
      pageSize
    }).subscribe(
      rs => {
        this.isTableLoading = false;
        // console.log(rs);
        if (rs == null || rs.data == null || rs.data.dataRow == null) {
          return 0;
        }
        this.paginate = {
          currentPage: rs.data.currentPage,
          pageSize: rs.data.pageSize,
          totalRow: rs.data.totalRow,
          totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
          totalPageArray: this.commonService.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
          no: this.commonService.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
        };
        this.dataSource.data = rs.data.dataRow;
      }, () => this.isTableLoading = false
    );
  }

  /**
   * Search user
   * @param page: number
   * @param pageSize: number
   */
  searchUser(page: number = 0, pageSize: number = 10) {
    let active;
    if (this.oldData.isActive == null || this.oldData.isActive === 'null') {
      active = [true, false];
    } else {
      active = [this.oldData.isActive === 'true'];
    }

    this.isTableLoading = true;
    // clear data cu: skeleton la footer-row nam duoi cung bang, neu giu data cu thi no nam
    // duoi man hinh -> clear de skeleton hien ngay duoi header nhu luc vua vao trang
    this.dataSource.data = [];
    this.userService.getAll({
      ...this.oldData,
      active,
      page,
      pageSize,
    }).subscribe(rs => {
      this.isTableLoading = false;
      if (rs == null || rs.data == null || rs.data.dataRow == null) {
        return;
      }
      this.paginate = {
        currentPage: rs.data.currentPage,
        pageSize: rs.data.pageSize,
        totalRow: rs.data.totalRow,
        totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
        totalPageArray: this.commonService.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
        no: this.commonService.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
      };
      this.dataSource.data = rs.data.dataRow;
    }, () => this.isTableLoading = false);
  }

  /**
   * Change user status
   * @param id: any
   */
  onChangeStatus(id: string, userName: string, userStatus: boolean) {
    // them trang thai nguoi ding vao warning
    var s1 = userStatus ? '<strong>' + this.message.getMessage('enterprise_document_template_add.cbx_document_status.cbx_document_status_active') + '</strong>'
      : '<strong>' + this.message.getMessage('enterprise_document_template_add.cbx_document_status.cbx_document_status_inactive') + '</strong>';

    var s2 = !userStatus ? '<strong>' + this.message.getMessage('enterprise_document_template_add.cbx_document_status.cbx_document_status_active') + '</strong>'
      : '<strong>' + this.message.getMessage('enterprise_document_template_add.cbx_document_status.cbx_document_status_inactive') + '</strong>';
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      // set Ten nguoi dung vao Message
      data: this.commonService.format(this.message.getMessage('messages.confirm_change_status'), userName, s1, s2)
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.userService.changeStatus(id).subscribe(
          () => {
            if (this.paginate.totalRow % this.paginate.pageSize === 1) {
              if (this.paginate.currentPage - 1 < 0) {
                this.paginate.currentPage = 0;
              } else {
                this.paginate.currentPage = this.paginate.currentPage - 1;
              }
            }
            this.toastr.success(this.message.getMessage('messages.update_status_success'));
            this.searchUser(this.paginate.currentPage, this.paginate.pageSize);
          });
      }
      this.focusInput.first.nativeElement.focus();
    });
  }

  /**
   * Edit user information
   */
  openDialogEdit(userId: any) {

    if( JSON.parse(localStorage.getItem('permissions')).includes(2) && localStorage.getItem('isFromSSO') =='true'){
      // window.location.href = 'http://10.207.252.76:8777/admin/role-management'
      window.open(this.sme_hub+'/admin/user-management','_blank');
      return
    }
    const dialogRef = this.dialog.open(UpdateUserComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '70%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
      // panelClass: 'scontract-overlay-dialog',
      autoFocus: true,
      data: {
        userId
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.searchUser(this.paginate.currentPage, this.paginate.pageSize);
      this.focusInput.first.nativeElement.focus();
    });
  }

  /**
   * Open Add dialog
   */
  openDialogAdd() {
    if( JSON.parse(localStorage.getItem('permissions')).includes(2) && localStorage.getItem('isFromSSO') =='true'){
      // window.location.href = 'http://10.207.252.76:8777/admin/user-management'
      window.open(this.sme_hub+'/admin/user-management','_blank');
      return
    }

    const dialogRef = this.dialog.open(AddUserComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '70%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
      // panelClass: 'scontract-overlay-dialog',
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(() => {
      this.searchUser(this.paginate.currentPage, this.paginate.pageSize);
      this.focusInput.first.nativeElement.focus();
    });
  }

  /**
   * Open Auth dialog
   */
  openDialogAutho(userId: any) {
    const dialogRef = this.dialog.open(AuthoUserComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '70%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
      // panelClass: 'scontract-overlay-dialog',
      data: {
        userId
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.searchUser(this.paginate.currentPage, this.paginate.pageSize);
      this.focusInput.first.nativeElement.focus();
    });
  }

  delete(id: any, userName: any, fullName: any) {
    const name = fullName + ' - ' + userName;
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.confirm_delete_user'), name)
    });
    dialogRef.afterClosed().subscribe(rs => {
      if (rs) {
        this.userService.removeUser({ userId: id } ).subscribe( result => {
          if (result.success) {
            this.toastr.success(this.message.getMessage('messages.delete_user_success_true'));
            this.loadData();
          } else {
            this.toastr.error(rs.mesage);
          }
        });
      }
    });
  }

  /**
   * Bind old search data to variable oldData to avoid error
   */
  onClickBtnFilter() {
    this.oldData = { ...this.user };
  }

  onImportFile() {
    // const dialogRe = this.dialog.open(ImportUserFileComponent, {
    //   width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '550px',
    //   maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
    //   panelClass: 'scontract-overlay-dialog',
    //   data: this.message.getMessage('messages.confirm_change_data')
    // });
    // dialogRe.afterClosed().subscribe(res => {
    //   this.searchUser(this.paginate.currentPage, this.paginate.pageSize);
    // })
    if( JSON.parse(localStorage.getItem('permissions')).includes(2) && localStorage.getItem('isFromSSO') =='true'){
      // window.location.href = 'http://10.207.252.76:8777/admin/user-management'
      window.open(this.sme_hub+'/admin/user-management','_blank');
      return
    }else{
      this.router.navigate(['home-enterprise/import-user']);
    }
  }

  get getPermisionSME(){
    if(JSON.parse(localStorage.getItem('permissions')).includes(2) && localStorage.getItem('isFromSSO') =='true'){
      return true
    }
    return false
  }
}
